import { BeneficiaryTypes } from './types';
import BeneficiaryTopContent from './parts/top-content';
import BeneficiaryStatusContent from './parts/status-content';
import BeneficiaryInfo from './parts/info';
import BeneficiaryTables from './parts/tables';

import cn from './styles.module.css';

const Beneficairy = ({
  beneficiary,
  errors,
  organizationStatus,
  statusInProgress,
  beneficiaryStatus,
  onSaveStatus,
  updateStatusError,
  setBeneficiaryStatus,
  setRejectPopupVisible,
  activePermissions,
  countries,
  globalValidateError,
  beneficiarySettings,
  contractsFormattedData,
  filters,
  contractsIsLoading,
  contractsIsFetching,
  beneficiaryContracts,
  formattedDocumentsData,
  documentsCategoriesIsLoading,
  documentsCategoriesIsFetching,
  beneficiaryContractsErrorsList,
  onRowClick,
}: BeneficiaryTypes) => (
  <>
    <div className={cn.beneficiaryContent}>
      <BeneficiaryTopContent
        beneficiary={beneficiary}
        errors={errors}
        organizationStatus={organizationStatus}
        statusInProgress={statusInProgress}
        beneficiaryStatus={beneficiaryStatus}
        onSaveStatus={onSaveStatus}
        updateStatusError={updateStatusError}
      />
      <BeneficiaryStatusContent
        beneficiaryStatus={beneficiaryStatus}
        beneficiary={beneficiary}
        setBeneficiaryStatus={setBeneficiaryStatus}
        organizationStatus={organizationStatus}
        setRejectPopupVisible={setRejectPopupVisible}
        activePermissions={activePermissions}
      />
    </div>
    <BeneficiaryInfo
      beneficiary={beneficiary}
      errors={errors}
      countries={countries}
      globalValidateError={globalValidateError}
    />
    <BeneficiaryTables
      beneficiarySettings={beneficiarySettings}
      contractsFormattedData={contractsFormattedData}
      filters={filters}
      contractsIsLoading={contractsIsLoading}
      contractsIsFetching={contractsIsFetching}
      beneficiaryContracts={beneficiaryContracts}
      beneficiaryContractsErrorsList={beneficiaryContractsErrorsList}
      beneficiary={beneficiary}
      formattedDocumentsData={formattedDocumentsData}
      documentsCategoriesIsLoading={documentsCategoriesIsLoading}
      documentsCategoriesIsFetching={documentsCategoriesIsFetching}
      onRowClick={onRowClick}
      errors={errors}
    />
  </>
);

export default Beneficairy;
